import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export const fetchNews = async () => {
    const response = await apiFetch(`${API_BASE}/news/client`);
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};

export const fetchUnreadNews = async () => {
    const response = await apiFetch(`${API_BASE}/news/client/unread`);
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};

export const markNewsViewed = async () => {
    const response = await apiFetch(`${API_BASE}/news/client/mark-viewed/news`, {
        method: "PUT",
    });
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};
